import Image from '@admin/components/image'
import PropTypes from 'prop-types'
import React from 'react'

const ResourceToken = ({ resource }) => (
  <div className="campaign-token">
    <div className="campaign-token-preview">
      <div className="campaign-token-preview-inner">
        <Image src={ resource.thumbnail?.path || `/${resource.asset?.preview}` } title={ resource.title } transforms={{ w: 80, h: 80, fit: 'cover' }} width={ 80 } height={ 80 } />
      </div>
    </div>
    <div className="campaign-token-label">
      <div className="token-link">
        { resource.title }
      </div>
      <div className="token-stats">
        { resource.type === 'document' ? 'Document' : 'Canva Design' }<br />
        <span>{ resource.description }</span>
      </div>
    </div>
  </div>
)

ResourceToken.propTypes = {
  resource: PropTypes.object
}

export default ResourceToken